export default __webpack_public_path__ + "static/media/bass.76691fb6.jpeg";